import React, { useState } from "react";
import BackButton from "src/legacy/components/BackButton";
import { Image } from "react-bootstrap";

import SalesforceIcon from "src/legacy/images/salesforce.png";
import SwitchButton from "src/components/switchButton";
import { localizedStrings } from "src/localization/index.jsx";
import styles from "./styles.module.scss";
import { useSelector } from "react-redux";
import _ from "lodash";

export const SalesforceSidebar = (props) => {
  const localizedCommons = localizedStrings.commons;
  const localizedIntegrations = localizedStrings.components.integrations;
  const localizedsalesforce = localizedStrings.components.integrations.salesforce;
  const localizedIntgerationActions = localizedStrings.components.integrations.actions;

  const [showSeeMore, setShowSeeMore] = useState(true);

  const integration = localizedStrings.constants.integrationsOnboarding.integrations.salesforce;
  const support_articles = integration.support_articles;

  const handleChange = () => {
    props.showIntergrationOnboarding();
  };

  const handleSeeMore = () => {
    const container = document.getElementById("articles");
    const element = container.querySelector("ol li:last-child");
    if (container) {
      const scrollHeight = element.offsetTop;
      container.scrollTo({ top: scrollHeight, behavior: "smooth" });
    }
    setShowSeeMore(false);
  };

  return (
    <div className={styles.sideBar}>
      <BackButton
        className={styles.back}
        title={localizedCommons.actions.back}
        onClick={() => {
          props.navigate("/settings/integrations");
        }}
      />
      <div className={styles.headerContainer}>
      <div className={styles.heading}>
        <Image src={SalesforceIcon} />
        <h2 className={styles.name}>{localizedsalesforce.title}</h2>
        <p className={styles.description}>{localizedsalesforce.sub_text}</p>
      </div>
      <div className={styles.actions}>
        {/* if primary integration token expires */}
        {/* isAuthenticated is true in case of secondary instance */}
        {((_.size(_.get(props, "integration")) > 0 && !props.isAuthenticated) ||(_.size(_.get(props, "integration")) > 0 && props.isPrimaryTokenExpired)) && props.canEdit() && (
            <button
              onClick={() => props.handleAuthenticate()}
              disabled={props.authenticating}
              className={styles.button}
            >
              {props.authenticating &&
                `${localizedIntgerationActions.authenticating}...`}
              {!props.authenticating &&
                localizedIntgerationActions.re_authenticate}{" "}
            </button>
          )}   

        {/* if primary integration is null */}
        {_.size(_.get(props, "integration")) == 0 && !props.isAuthenticated && props.canEdit() && (
            <button
              onClick={() => props.handleAuthenticate()}
              disabled={props.authenticating}
              className={styles.button}
            >
              {props.authenticating &&
                localizedIntgerationActions.authenticating + "..."}
              {!props.authenticating &&
                localizedIntgerationActions.authenticate}
            </button>
          )}

        {_.size(_.get(props, "integration")) > 0 && props.isAuthenticated && !props.isPrimaryTokenExpired && props.canEdit() && (
            <button
              className={styles.button}
              disabled={props.deactivating}
              onClick={() => props._handleDeactivateClicked()}
            >
              {props.deactivating &&
                `${localizedIntgerationActions.deactivating}...`}
              {!props.deactivating && localizedIntgerationActions.deactivate}
            </button>
          )}
      </div>
      </div>
      <div className={styles.footerContainer}>
      <div className={styles.footer}>
        <div className={styles.articles} id="articles">
          <span>{support_articles.title}</span>
          <ol>
            {support_articles.content.map((article, index) => {
              return (
                <li key={index} className={styles.article}>
                  <a href={article.url} target="_blank">
                    {article.title}
                  </a>
                </li>
              );
            })}
          </ol>
        </div>
        {_.size(support_articles.content) > 4 && showSeeMore && (
          <div className={styles.seeMore} onClick={handleSeeMore}>
            {localizedCommons.actions.see_more}
          </div>
        )}
          {_.size(_.get(props, "integration")) > 0 && (
          <div className={styles.moreActions}>
          <span>{localizedIntegrations.learn_more}</span>
          <SwitchButton
            id={`integrationOnboarding`}
            label={localizedIntgerationActions.show_onboarding_label}
            checked={props.showIntergrationOnboardingState}
            handleCheck={handleChange} />
        </div>
      )}
        </div>
      </div>
    </div>
  );
};
